module.exports = __webpack_public_path__ + "img/IMG_1747.d17a5ca9.jpg";